import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-ncert-aligned-digital-k12-content-what-schools-should-know',
  templateUrl: './ncert-aligned-digital-k12-content-what-schools-should-know.component.html',
  styleUrls: ['./ncert-aligned-digital-k12-content-what-schools-should-know.component.scss']
})
export class NcertAlignedDigitalK12ContentWhatSchoolsShouldKnowComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('NCERT-Aligned Digital K–12 Content for Schools | VIRSA');
    this.metaService.updateTag({
      name: 'description',
      content: 'Understand how NCERT-aligned digital K–12 content supports curriculum-based learning, interactive teaching, assessments, and better classroom engagement. Explore VIRSA digital learning content for schools.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'NCERT aligned digital K-12 content, NCERT aligned digital content for schools, K-12 digital learning content, digital content for schools, NCERT based digital content, digital education content for schools, interactive K-12 learning content, K-12 educational content, digital classroom content, VIRSA K-12 digital content, smart classroom digital content, curriculum aligned digital learning, digital learning resources for schools, school digital education solutions, interactive educational content, K-12 e-learning content, digital teaching resources, school classroom technology'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
